export enum OrganizationType {
    Broker = 'Broker',
    Capitola = 'Capitola',
    Carrier = 'Carrier',
    Retailer = 'Retailer',
    Insured = 'Insured',
    Issuer = 'Issuer',
}

export const MarketOrganizationTypes = [OrganizationType.Broker, OrganizationType.Carrier];

export function isMarketOrganization(organizationType?: OrganizationType) {
    if (!organizationType) {
        return false;
    }

    return MarketOrganizationTypes.includes(organizationType);
}

export function isInsuredOrganization(organizationType?: OrganizationType) {
    if (!organizationType) {
        return false;
    }
    return organizationType === OrganizationType.Insured;
}

export function isCustomerOrganization(organizationType?: OrganizationType) {
    if (!organizationType) {
        return false;
    }

    return organizationType === OrganizationType.Retailer;
}

export function isUserOrganization(organizationType: OrganizationType): boolean {
    return [OrganizationType.Retailer, OrganizationType.Capitola].includes(organizationType);
}
